module.exports = __webpack_public_path__ + "fonts/VetoSansCond-MediumItalic.b329abbe.eot";